import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputOneDriveFspConfig<T extends EMode = EMode.entity> {
  /** Alias: siteId */
  siteId?: any;
  /** Alias: driveId */
  driveId?: any;
  /** Alias: clientId */
  clientId?: any;
  /** Alias: tenantId */
  tenantId?: any;
  /** Alias: clientSecret */
  clientSecret?: any;

  __typename?: string;
}

const fields: FieldDefinitions<InputOneDriveFspConfig> = {
  siteId: {
    alias: 'siteId',
  },
  driveId: {
    alias: 'driveId',
  },
  clientId: {
    alias: 'clientId',
  },
  tenantId: {
    alias: 'tenantId',
  },
  clientSecret: {
    alias: 'clientSecret',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputOneDriveFspConfigEntityDefinition: EntitiyDefinition<InputOneDriveFspConfig> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputOneDriveFspConfig',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
